import styled from 'styled-components'
import { v1 as color } from 'sidecar-design-library'

export const Date = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const Year = styled.div`
  font-size: 0.875rem;
  line-height: 0.625rem;
  color: ${color.GREY};
`

export const Month = styled.div`
  font-size: 0.875rem;
  line-height: 0.625rem;
  color: ${color.GREY};
`

export const Day = styled.div`
  font-size: 1.5rem;
  line-height: 1.875rem;
  color: ${color.LIGHT_CHARCOAL};
`
